import React, { useState, useRef, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-easy-crop";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import getCroppedImg from "./cropImage.js";
import "./info.scss";
import TokenomicsChartModal from "../Banner/modals/tokenomicsModal.js";
import AddTeamMemberModal from "../Banner/modals/addTeam.js";

const Information = ({
  basicInfo,
  setBasicInfo,
  projectSetup,
  teamFormData,
  setProjectSetup,
  setLoader,
  setTeamFormData,
}) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const handleChange = (field, value) => {
    setBasicInfo((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        value,
        error: false,
      },
    }));
  };
  const removeDocument = () => {
    setCroppedImage(null);
    setImageSrc(null);
    fileInputRef.current.value = "";
  };

  const [showCrop, setShowCrop] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const fileInputRef = useRef(null);

  const handleCloseCrop = () => setShowCrop(false);

  const openFilePicker = () => {
    fileInputRef.current.click();
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 3 * 1024 * 1024) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCrop(true);
      };
    } else {
      alert("Image must be less than 3MB");
    }
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSaveCrop = async () => {
    try {
      const cropped = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedImage(cropped);
      setCroppedImage(cropped);
      setShowCrop(false);
      setZoom(1);
    } catch (err) {
      console.log(err);
    }
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show12, setShow12] = useState(false);
  const handleClose12 = () => setShow12(false);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => {
    setShow1(false);
    setEditingIndex(null);
  };

  const handleShow1 = () => {
    setShow1(true);
  };

  const [show11, setShow11] = useState(false);

  const handleClose11 = () => setShow11(false);
  const handleShow11 = () => setShow11(true);

  // Check if first team member is empty
  const isFirstTeamMemberEmpty = (team) => {
    if (!team || team.length === 0) return true;

    const firstMember = team[0];
    return (
      (!firstMember.name || firstMember.name.trim() === "") &&
      (!firstMember.designation || firstMember.designation.trim() === "") &&
      (!firstMember.bio || firstMember.bio.trim() === "") &&
      !firstMember.image
    );
  };

  const [tempDesc, setTempDesc] = useState(basicInfo?.details?.value || "");
  const saveDescription = () => {
    let value = tempDesc;
    setBasicInfo((prev) => ({
      ...prev,
      ["details"]: {
        ...prev["details"],
        value,
        error: false, // clear error on change
      },
    }));
    handleClose12();
  };

  const isQuillEmpty = (value) => {
    if (!value) return true;

    // Remove HTML tags and check if there's actual text
    const text = value
      .replace(/<[^>]*>/g, "") // Remove all HTML tags
      .replace(/&nbsp;/g, "") // Remove &nbsp;
      .trim();

    return text.length === 0;
  };

  const handleRemoveBoth = () => {
    setProjectSetup((prev) => ({
      ...prev,
      tokenomicsChartLight: {
        ...prev.tokenomicsChartLight,
        value: null,
        error: false,
        errorMsg: "",
      },
      tokenomicsChartDark: {
        ...prev.tokenomicsChartDark,
        value: null,
        error: false,
        errorMsg: "",
      },
    }));
  };

  // For editing a team member
  const handleEditMember = (index) => {
    setEditingIndex(index);
    setShow1(true);
  };

  // For deleting a team member
  const handleDeleteMember = (index) => {
    const updatedTeam = teamFormData.team.filter((_, i) => i !== index);
    setTeamFormData((prev) => ({
      ...prev,
      team: updatedTeam,
    }));
  };

  const handleDeleteAllTeams = () => {
    setTeamFormData((prev) => ({
      ...prev,
      team: [],
    }));
  };

  return (
    <>
      <div className="outer_information">
        <div className="project_information">
          <h2>Project Information</h2>
          <button onClick={() => setShow12(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M5.25 15.75L15 6L12 3L2.25 12.75V15.75H5.25Z"
                stroke="#329879"
                stroke-width="1.5"
              />
              <path
                d="M10.125 4.875L13.125 7.875"
                stroke="#329879"
                stroke-width="1.5"
              />
              <path d="M8.25 15.75H16.5" stroke="#329879" stroke-width="1.5" />
              <path d="M16.5 12.75H11.25" stroke="#329879" stroke-width="1.5" />
            </svg>
            Edit
          </button>
        </div>
        <section className="information-section">
          <div
            className="first-para"
            dangerouslySetInnerHTML={{ __html: basicInfo?.details?.value }}
          />
          {/* <div className="first-para" style={{ margin: "0" }}>
            <h2 className="projectdiv">
              Decentralizing Trust in Gaming <span></span>
            </h2>
            <p>
              Luckify is redefining the world of chance-based gaming by putting
              fairness on-chain. From casino-style games and lotteries to loot
              boxes and prize draws, randomness fuels the excitement—but too
              often, it’s controlled in the shadows.
            </p>
            <p>
              Luckify flips the script with a Verifiable Randomness
              Engine powered by Chainlink VRF and the LUCK token, ensuring every
              outcome is tamper-proof, auditable, and economically grounded.
            </p>
            <h2>
              How It Works <span></span>
            </h2>
            <ol>
              <li>
                Player initiates a request for randomness via smart contract
              </li>
              <li>
                Chainlink VRF delivers a cryptographically secure random number
              </li>
              <li>Smart contract verifies the number</li>
              <li>
                LUCK/BNB price data is optionally used to add contextual entropy
              </li>
              <li>The final result determines game outcomes on-chain</li>
            </ol>

            <h2>
              Why It Matters <span></span>
            </h2>
            <ol>
              <li>
                Zero Trust Required: Trust code, not centralized operators
              </li>
              <li>
                On-Chain Transparency: Every outcome is verifiable and public
              </li>
              <li>Tamper-Proof RNG: Secured by Chainlink VRF</li>
              <li>
                Economic Anchoring: Token price adds real-world influence to
                results
              </li>
            </ol>
          </div>
          <div className="first-para">
            <h2>
              Use Cases <span></span>
            </h2>
          </div>
          <div className="first-para">
            <ul>
              <li>Provably fair casino games & betting</li>
              <li>Public RNG for PvP & skill-based games</li>
              <li>Loot boxes, giveaways, NFT mints</li>
              <li>Developer integration via API & SDK</li>
            </ul>
          </div>

          <div className="first-para">
            <h2>
              Roadmap <span></span>
            </h2>
          </div>
          <div className="first-para">
            <ul>
              <li>v1: Chainlink VRF + Token Price Integration (Live)</li>
              <li>v2: Community-powered entropy via staked LUCK</li>
              <li>
                v3: Fully decentralized RNG mesh governed by DAO-operated nodes
              </li>
              <p>
                Each version deepens decentralization and increases fairness.
              </p>
            </ul>
          </div>
          <div className="first-para">
            <h2>
              Token Utility: $LUCK <span></span>
            </h2>
          </div>
          <div className="first-para">
            <ul>
              <li>Pay for randomness requests</li>
              <li>Stake to power future RNG nodes</li>
              <li>Earn rewards by validating results</li>
              <li>Vote on ecosystem upgrades and parameters </li>
            </ul>
          </div> */}
        </section>
        <div className="document-section information-section tokeenms">
          <div className="highlight_Div latessssst">
            <h2>
              TOKENOMICS <span></span>
            </h2>
            <div className="bothbuttons">
              {projectSetup?.tokenomicsChartLight?.value ? (
                <button
                  onClick={() => handleRemoveBoth()}
                  className="delbutton"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M12.375 7.5H5.625"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12 10.125H6"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path
                      d="M11.625 12.75H6.375"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path
                      d="M14.625 4.5L13.5 15.75H4.5L3.375 4.5"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path d="M6 2.25H12" stroke="#FC4F52" stroke-width="1.5" />
                    <path
                      d="M16.5 4.5H1.5"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                  </svg>{" "}
                  Delete
                </button>
              ) : (
                <>
                  {projectSetup?.tokenomicsChartDark?.value && (
                    <button
                      onClick={() => handleRemoveBoth()}
                      className="delbutton"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M12.375 7.5H5.625"
                          stroke="#FC4F52"
                          stroke-width="1.5"
                        />
                        <path
                          d="M12 10.125H6"
                          stroke="#FC4F52"
                          stroke-width="1.5"
                        />
                        <path
                          d="M11.625 12.75H6.375"
                          stroke="#FC4F52"
                          stroke-width="1.5"
                        />
                        <path
                          d="M14.625 4.5L13.5 15.75H4.5L3.375 4.5"
                          stroke="#FC4F52"
                          stroke-width="1.5"
                        />
                        <path
                          d="M6 2.25H12"
                          stroke="#FC4F52"
                          stroke-width="1.5"
                        />
                        <path
                          d="M16.5 4.5H1.5"
                          stroke="#FC4F52"
                          stroke-width="1.5"
                        />
                      </svg>{" "}
                      Delete
                    </button>
                  )}
                </>
              )}

              <button onClick={handleShow} className="changesbutton">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M5.25 15.75L15 6L12 3L2.25 12.75V15.75H5.25Z"
                    stroke="#329879"
                    stroke-width="1.5"
                  />
                  <path
                    d="M10.125 4.875L13.125 7.875"
                    stroke="#329879"
                    stroke-width="1.5"
                  />
                  <path
                    d="M8.25 15.75H16.5"
                    stroke="#329879"
                    stroke-width="1.5"
                  />
                  <path
                    d="M16.5 12.75H11.25"
                    stroke="#329879"
                    stroke-width="1.5"
                  />
                </svg>
                Change Image
              </button>
            </div>
          </div>
          <div className="first-para">
            <div className="twice-tokenomics">
              <div className="tokenomic-img">
                {projectSetup?.tokenomicsChartLight?.value ? (
                  <img
                    src={projectSetup?.tokenomicsChartLight?.value}
                    alt="img"
                    className="img-fluid imgnewsidee"
                  />
                ) : (
                  <>
                    {projectSetup?.tokenomicsChartDark?.value && (
                      <img
                        src={projectSetup?.tokenomicsChartDark?.value}
                        alt="img"
                        className="img-fluid imgnewsidee"
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="document-section information-section tokeenms">
          <div className="highlight_Div">
            <h2>
              The Team <span></span>
            </h2>
            <div className="bothbuttons">
              {!isFirstTeamMemberEmpty(teamFormData?.team) && (
                <button
                  onClick={() => handleDeleteAllTeams()}
                  className="delbutton"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M12.375 7.5H5.625"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12 10.125H6"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path
                      d="M11.625 12.75H6.375"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path
                      d="M14.625 4.5L13.5 15.75H4.5L3.375 4.5"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                    <path d="M6 2.25H12" stroke="#FC4F52" stroke-width="1.5" />
                    <path
                      d="M16.5 4.5H1.5"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                    />
                  </svg>{" "}
                  Delete
                </button>
              )}
              <button onClick={handleShow1} className="changesbutton">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6 9.75C8.48527 9.75 10.5 11.7647 10.5 14.25V15.75H1.5V14.25C1.5 11.7647 3.51472 9.75 6 9.75Z"
                    stroke="#329879"
                    stroke-width="1.5"
                  />
                  <path
                    d="M3.375 4.875C3.375 6.32475 4.55025 7.5 6 7.5C7.44975 7.5 8.625 6.32475 8.625 4.875C8.625 3.42525 7.44975 2.25 6 2.25C4.55025 2.25 3.375 3.42525 3.375 4.875Z"
                    stroke="#329879"
                    stroke-width="1.5"
                  />
                  <path
                    d="M14.2499 5.25V8.25M14.2499 8.25V11.25M14.2499 8.25H17.25M14.2499 8.25H11.25"
                    stroke="#329879"
                    stroke-width="1.5"
                  />
                </svg>
                Add Team Member
              </button>
            </div>
          </div>

          <div className="first-para">
            <div className="team-gems">
              {!isFirstTeamMemberEmpty(teamFormData?.team) &&
                teamFormData?.team?.map((item, index) => {
                  return (
                    <div className="single-team" key={index}>
                      <div className="bothbuttons">
                        <button
                          className="delbutton"
                          onClick={() => handleDeleteMember(index)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                          >
                            <path
                              d="M9.625 5.83203H4.375"
                              stroke="#FC4F52"
                              stroke-width="1.2"
                            />
                            <path
                              d="M9.33341 7.875H4.66675"
                              stroke="#FC4F52"
                              stroke-width="1.2"
                            />
                            <path
                              d="M9.04183 9.91797H4.9585"
                              stroke="#FC4F52"
                              stroke-width="1.2"
                            />
                            <path
                              d="M11.375 3.5L10.5 12.25H3.5L2.625 3.5"
                              stroke="#FC4F52"
                              stroke-width="1.2"
                            />
                            <path
                              d="M4.66675 1.75H9.33341"
                              stroke="#FC4F52"
                              stroke-width="1.2"
                            />
                            <path
                              d="M12.8334 3.5H1.16675"
                              stroke="#FC4F52"
                              stroke-width="1.2"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => handleEditMember(index)}
                          className="changesbutton"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                          >
                            <path
                              d="M4.08333 12.2487L11.6667 4.66537L9.33334 2.33203L1.75 9.91537V12.2487H4.08333Z"
                              stroke="#329879"
                              stroke-width="1.2"
                            />
                            <path
                              d="M7.875 3.78906L10.2083 6.1224"
                              stroke="#329879"
                              stroke-width="1.2"
                            />
                            <path
                              d="M6.41675 12.25H12.8334"
                              stroke="#329879"
                              stroke-width="1.2"
                            />
                            <path
                              d="M12.8333 9.91406H8.75"
                              stroke="#329879"
                              stroke-width="1.2"
                            />
                          </svg>
                          Edit
                        </button>
                      </div>
                      <img src={item?.image} alt="img" className="img-fluid" />
                      <h6>{item?.name} </h6>
                      <span className="spannstext">{item?.designation}</span>
                      <p>{item?.bio}</p>
                    </div>
                  );
                })}
            </div>
          </div>
          {/* <div className="first-para">
            <h2>
              WHO ARE THE COLLABORATORS OF DOP? <span></span>
            </h2>
            <p>
              DOP has established key collaborations with leading blockchain
              technology providers to enhance the security, compliance, and user
              privacy of its protocol. These include partnerships with
              Chainalysis for data protection, zkMe for privacy-preserving
              identity verification, and Hacken for comprehensive protocol
              auditing.
            </p>
          </div> */}
        </div>
      </div>
      <TokenomicsChartModal
        show={show}
        handleClose={() => setShow(false)}
        projectSetup={projectSetup}
        setProjectSetup={setProjectSetup}
        setLoader={setLoader}
      />
      {/* <Modal
        className="publish-modall"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="publish_modal">
            <div className="tokicsimg">
              <div className="chart_left">
                <h4>Tokenomics Chart (Dark Theme)</h4>
                <div className="replace_Sides">
                  <img src="\assets\imgtoken.png" />
                  <div className="buttons_modals">
                    <button className="replace">Replace</button>
                    <button className="remove">Remove</button>
                  </div>
                </div>
              </div>
              <div className="chart_left">
                <h4>Tokenomics Chart (Light Theme)</h4>
                <div className="replace_Sides">
                  <img src="\assets\imgtoken.png" />
                  <div className="buttons_modals">
                    <button className="replace">Replace</button>
                    <button className="remove">Remove</button>
                  </div>
                </div>
              </div>
            </div>
            <p className="psmall">
              1848x1050 resolution. Max 3 MB in JPEG or PNG format
            </p>
            <p className="psmallnew">
              Images in 2880x660 resolution. Max 15 MB in JPEG or PNG format
            </p>
            <div className="publish_buttons">
              <button onClick={handleClose} className="cancel_button">
                Cancel
              </button>
              <button
                className="confirm_button"
                onClick={() => {
                  handleShow();
                  handleClose();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
      <AddTeamMemberModal
        show1={show1}
        handleClose1={handleClose1}
        teamFormData={teamFormData}
        setTeamFormData={setTeamFormData}
        setLoader={setLoader}
        editingIndex={editingIndex}
      />
      {/* <Modal
        className="publish-modall addteammembermodal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Team Member</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="publish_modal">
            <div className="team_member">
              <div className="innner_team">
                <div className="left_team">
                  <div className="edit_img">
                    {croppedImage ? (
                      <img
                        src={croppedImage}
                        alt="cropped preview"
                        className="teamPreview"
                        onClick={openFilePicker}
                      />
                    ) : (
                      <img
                        src="/assets/downlodnew.svg "
                        onClick={openFilePicker}
                        className="ediiiiit"
                      />
                    )}
                  </div>
                  <div>
                    <p>800×800 resolution • Max 3MB • JPEG/PNG</p>
                    <div>
                      {!croppedImage && (
                        <button onClick={openFilePicker}>Upload Image</button>
                      )}

                      {croppedImage && (
                        <div className="replacesbutton">
                          <button onClick={openFilePicker}>Replace</button>
                          <div
                            className="delllbuts"
                            onClick={removeDocument}
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M2 4H14"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12.6663 4V13.3333C12.6663 14 11.9997 14.6667 11.333 14.6667H4.66634C3.99967 14.6667 3.33301 14 3.33301 13.3333V4"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.33301 3.9987V2.66536C5.33301 1.9987 5.99967 1.33203 6.66634 1.33203H9.33301C9.99967 1.33203 10.6663 1.9987 10.6663 2.66536V3.9987"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M6.66699 7.33203V11.332"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.33301 7.33203V11.332"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    ref={fileInputRef}
                    onChange={onFileChange}
                  />
                </div>

                <div className="under_div">
                  <div className="under_review">
                    <div>
                      <h3>Full Name</h3>
                      <input
                        type="text"
                        placeholder="Enter full name"
                        onChange={(e) => {}}
                      />
                    </div>
                    <div>
                      <h3>Designation</h3>
                      <input
                        type="text"
                        placeholder="Enter Designation"
                        onChange={(e) => {}}
                      />
                    </div>
                  </div>

                  <div>
                    <h3>Bio</h3>
                    <textarea
                      placeholder="Team member bio"
                      rows="4"
                      cols="50"
                    ></textarea>
                  </div>
                  <p className="charactersize">289/300 Character</p>
                </div>
              </div>
            </div>

            <div className="publish_buttons">
              <button onClick={handleClose1} className="cancel_button">
                Cancel
              </button>
              <button className="confirm_button">Add</button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
      <Modal
        className="publish-modall addteammembermodal"
        show={show11}
        onHide={handleClose11}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Team Member</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="publish_modal">
            <div className="team_member">
              <div className="innner_team">
                <div className="left_team">
                  <div className="edit_img">
                    {croppedImage ? (
                      <img
                        src={croppedImage}
                        alt="cropped preview"
                        className="teamPreview"
                        onClick={openFilePicker}
                      />
                    ) : (
                      <img
                        src="/assets/person.svg "
                        onClick={openFilePicker}
                        className="ediiiifit"
                      />
                    )}
                  </div>
                  <div>
                    <p>800×800 resolution • Max 3MB • JPEG/PNG</p>
                    <div className="replacesbutton">
                      <button onClick={openFilePicker}>Replace</button>
                      <div className="delllbuts">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M2 4H14"
                            stroke="#FC4F52"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.6663 4V13.3333C12.6663 14 11.9997 14.6667 11.333 14.6667H4.66634C3.99967 14.6667 3.33301 14 3.33301 13.3333V4"
                            stroke="#FC4F52"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5.33301 3.9987V2.66536C5.33301 1.9987 5.99967 1.33203 6.66634 1.33203H9.33301C9.99967 1.33203 10.6663 1.9987 10.6663 2.66536V3.9987"
                            stroke="#FC4F52"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6.66699 7.33203V11.332"
                            stroke="#FC4F52"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.33301 7.33203V11.332"
                            stroke="#FC4F52"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    ref={fileInputRef}
                    onChange={onFileChange}
                  />
                </div>

                <div className="under_div">
                  <div className="under_review">
                    <div>
                      <h3>Full Name</h3>
                      <input
                        type="text"
                        placeholder="Enter full name"
                        onChange={(e) => {}}
                      />
                    </div>
                    <div>
                      <h3>Designation</h3>
                      <input
                        type="text"
                        placeholder="Enter Designation"
                        onChange={(e) => {}}
                      />
                    </div>
                  </div>

                  <div>
                    <h3>Bio</h3>
                    <textarea
                      placeholder="Team member bio"
                      rows="4"
                      cols="50"
                    ></textarea>
                  </div>
                  <p className="charactersize">289/300 Character</p>
                </div>
              </div>
            </div>

            <div className="publish_buttons">
              <button onClick={handleClose1} className="cancel_button">
                Cancel
              </button>
              <button className="confirm_button">Add</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="publish-modall"
        show={showCrop}
        onHide={handleCloseCrop}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="publish_modal">
            <div className="croopppy">
              <div className="cropmodal">
                {imageSrc && (
                  <div
                    className="crop-container inercrop"
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "240px",
                      background: "#E7EEF2",
                      borderRadius: "4px",
                      overflow: "hidden",
                    }}
                  >
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                )}
              </div>
              <p>Drag to reposition image</p>

              <div className="zoom-slider">
                <h5>Zoom</h5>
                <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={(e) => setZoom(Number(e.target.value))}
                  style={{
                    width: "100%",
                    height: "8px",
                    borderRadius: "10px",
                    appearance: "none",
                    background: `linear-gradient(to right, #329879 0%, #329879 ${
                      ((zoom - 1) / 2) * 100
                    }%, #d0d7de ${((zoom - 1) / 2) * 100}%, #d0d7de 100%)`,
                    outline: "none",
                  }}
                />
              </div>
              <div className="publish_buttons">
                <button className="cancel_button" onClick={handleCloseCrop}>
                  Cancel
                </button>
                <button className="confirm_button" onClick={handleSaveCrop}>
                  Save Cropped Image
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="publish-modall"
        show={show12}
        onHide={handleClose12}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Project Details</Modal.Title>
        </Modal.Header>

        {console.log("ttttttt", tempDesc)}

        <Modal.Body>
          <div className="publish_modal">
            <div className="innner_pin" style={{ margin: "20px 0" }}>
              <ReactQuill
                className={
                  "editorrr neweditooor" +
                  (basicInfo?.details?.error ? "error" : "")
                }
                theme="snow"
                value={tempDesc || ""}
                onChange={(value) => setTempDesc(value)}
                modules={modules}
                formats={formats}
                placeholder="Project Details"
                style={{ height: "112px" }}
              />
            </div>
            <div className="publish_buttons">
              <button className="cancel_button" onClick={handleClose12}>
                Cancel
              </button>
              <button
                className="confirm_button"
                style={{ opacity: isQuillEmpty(tempDesc) ? 0.5 : 1 }}
                disabled={isQuillEmpty(tempDesc)}
                onClick={() => saveDescription()}
              >
                Save Changes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Information;
